import {fonts, colors} from './config';
import styled from '@emotion/styled';
import {Link} from 'react-router-dom';
import {Link as LinkUI} from 'ui';

export const buttonStyle = {
  fontFamily: fonts.title,
  fontWeight: 'bold',
  fontSize: 18,
  lineHeight: '19px',
  padding: '12px 54px',
  textDecoration: 'none',
};

const ButtonInner = styled(({size, color, ...p}) => <span {...p} />)(({color}) => ({
  ...buttonStyle,
  border: `1px solid ${colors.white}`,
  color: color === 'white' ? colors.white : colors.caramel,
  backgroundColor: color === 'white' ? colors.caramel : colors.white,
  borderColor: color === 'white' ? colors.white : colors.caramel,
  width: 'inherit',
  maxWidth: 500,
  textAlign: 'center',
}));

export const Button = styled(({size, color, children, to, ...p}) => (
  <Link to={to} type="submit" {...p}>
    <ButtonInner size={size} color={color}>
      {children || 'Submit'}
    </ButtonInner>
  </Link>
))(({color}) => ({
  display: 'inline-flex',
  width: 'max-content',
  maxWidth: 500,
  padding: 2,
  backgroundColor: color === 'white' ? colors.caramel : colors.white,
  marginBottom: 16,
  textDecoration: 'none',
}));

export const ButtonLink = styled(({size, color, children, to, ...p}) => (
  <LinkUI {...p}>
    <ButtonInner size={size} color={color}>
      {children}
    </ButtonInner>
  </LinkUI>
))(({color}) => ({
  display: 'inline-flex',
  width: 'max-content',
  maxWidth: 500,
  padding: 2,
  backgroundColor: color === 'white' ? colors.caramel : colors.white,
  marginBottom: 16,
  textDecoration: 'none',
}));

export const Submit = styled(({size, color, children, ...p}) => (
  <button type="submit" {...p}>
    <ButtonInner size={size} color={color}>
      {children || 'Submit'}
    </ButtonInner>
  </button>
))(({color, disabled}) => ({
  display: 'inline-flex',
  width: 'max-content',
  padding: 2,
  backgroundColor: color === 'white' ? colors.caramel : colors.white,
  marginBottom: 16,
  border: 'none',
  opacity: disabled ? 0.7 : null,
}));

export const ButtonFlat = styled(Link)({
  ...buttonStyle,
  display: 'inline-flex',
  color: colors.white,
  backgroundColor: colors.caramel,
  border: 'none',
});

export const ButtonFlatLink = styled('a')({
  ...buttonStyle,
  display: 'inline-flex',
  color: colors.white,
  backgroundColor: colors.caramel,
  border: 'none',
  padding: '13px 26px',
  textAlign: 'center',
});

export const ButtonOutlined = styled(Link)({
  ...buttonStyle,
  display: 'inline-flex',
  color: colors.caramel,
  backgroundColor: colors.white,
  border: `3px double ${colors.caramel}`,
});
